export const ROOT = '/test';
export const MODULE = 'TEST';
